import React, { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Style from "../../assets/styles/layout.module.scss";
import { Sidebar, Header } from "../_index";
import { Menu, HRMenu, PMMenu, ITMenu } from "../../constant/SidebarMenu";
import ItResponsibilityPrompt from "./ItResponsibilityPrompt";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";
import { ROLES } from "../../constant/constant";
import axios from "axios";
import hrLoginStatusService from "../../services/hrLoginStatus.service";
import moment from "moment";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menu, setMenu] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [showHrModal, setShowHrModal] = useState(false);
  const [hrLoginData, setHrLoginData] = useState(null);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") || localStorage.getItem("token");
    const userId = params.get("userid") || localStorage.getItem("userId");
    const projectId =
      params.get("projectId") || localStorage.getItem("projectId");
    const isOverAllAdmin =
      params.get("isOverAllAdmin") || localStorage.getItem("isOverAllAdmin");

    if (token) {
      axios
        .post(`${process.env.REACT_APP_MAIN_URL}/decodeToken`, {
          token,
          userId,
          projectId,
        })
        .then((res) => {
          const item = res.data.data || {};
          const receivedProject = item?.projectData?.find(
            (proj) => proj.name === "Feedback"
          );
          // if (item.isPasswordChanged == false) {
          //   setOpenChangePassword(true);
          //   setCurrentUserId(userId);
          // }
          const projectRoleName = receivedProject?.role;
          const definedRole = JSON.parse(isOverAllAdmin)
            ? ROLES[0]
            : projectRoleName;
          if (definedRole === ROLES[0]) {
            setMenu(Menu);
          } else if (definedRole === ROLES[1]) {
            setMenu(HRMenu);
          } else if (definedRole === ROLES[3]) {
            setMenu(ITMenu);
          } else if (definedRole === ROLES[2]) {
            setMenu(PMMenu);
          } else {
            setMenu([]);
          }

          localStorage.setItem("isOverAllAdmin", item.isOverAllAdmin);
          localStorage.setItem("role", definedRole);
          localStorage.setItem("name", item?.name);
          localStorage.setItem("token", token);
          localStorage.setItem("email", item?.email);
          localStorage.setItem("userId", userId);
          localStorage.setItem("projectId", projectId);
          localStorage.setItem("userName", item?.userName);

          setIsAuthenticated(true);
        })
        .catch(() => {
          setIsAuthenticated(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setIsAuthenticated(false);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!loading && isAuthenticated === false) {
      navigate("/login");
    }
  }, [loading, isAuthenticated, location.pathname]);

  useEffect(() => {
    const checkHrStatus = async () => {
      const role = localStorage.getItem("role");
      const userId = localStorage.getItem("userId");
      const userName = localStorage.getItem("userName");

      if (isAuthenticated && role === "HR" && userId) {
        try {
          const statusResponse = await hrLoginStatusService.checkHrLoginStatusToday(userId);
          if (!statusResponse?.data?.hasLoginToday) {
            setHrLoginData({
              hrId: userId,
              name: userName,
              assignedName: statusResponse?.data?.assignedName,
            });
            setShowHrModal(true);
          }
        } catch (error) {
          console.error("Layout - Error checking HR login status:", error);
        }
      }
    };
    checkHrStatus();
  }, [isAuthenticated]);

  const handleHrFirstPerson = async (isFirstPerson) => {
    if (isFirstPerson && hrLoginData) {
      try {
        const now = moment();
        const payload = {
          hrId: hrLoginData.hrId,
          name: hrLoginData.name,
          date: now.format("YYYY-MM-DD"),
          time: now.format("hh:mm A"),
        };
        await hrLoginStatusService.saveHrLoginStatus(payload);
      } catch (error) {
        console.error("Error saving HR login status:", error);
      }
    }
    setShowHrModal(false);
  };


  const handleNavigate = useCallback((e) => {
    if (e === "login") {
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("role");
      localStorage.removeItem("projectId");
      localStorage.removeItem("isOverAllAdmin");
      localStorage.removeItem("isAdmin");
      window.location.href = process.env.REACT_APP_LOGOUT_URL;
      // navigate("/login");
    } else {
      navigate(e.path);
    }
  }, [navigate]);

  // sidebarMode: "collapsed" (icon-only), "expanded" (full), "hidden" (fully gone)
  const [sidebarMode, setSidebarMode] = useState("collapsed");
  const clickTimerRef = useRef(null);

  // Single click → toggle between collapsed ↔ expanded
  // Double click → hide sidebar completely
  const handleChevronClick = useCallback(() => {
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
      clickTimerRef.current = null;
      setSidebarMode("hidden");
    } else {
      clickTimerRef.current = setTimeout(() => {
        clickTimerRef.current = null;
        setSidebarMode((prev) => (prev === "expanded" ? "collapsed" : "expanded"));
      }, 280);
    }
  }, []);

  const showSidebar = useCallback(() => setSidebarMode("collapsed"), []);

  const isCollapsed = sidebarMode === "collapsed";

  return (
    <>
      {openChangePassword ? (
        <ChangePasswordModal
          open={openChangePassword}
          onClose={() => setOpenChangePassword(false)}
          userId={currentUserId}
        />
      ) : (
        <div className={Style.layoutContainer}>
          <div
            className={Style.sidebar}
            style={{
              width: sidebarMode === "hidden" ? "0px" : sidebarMode === "collapsed" ? "80px" : "18%",
              minWidth: sidebarMode === "hidden" ? "0px" : undefined,
              overflow: sidebarMode === "hidden" ? "hidden" : "visible",
              transition: "width 0.3s",
              position: "relative",
            }}
          >
            {sidebarMode !== "hidden" && (
              <Sidebar
                menu={menu}
                title="STAFF CONNECT"
                onNavigate={handleNavigate}
                isCollapsed={isCollapsed}
                toggleSidebar={handleChevronClick}
              />
            )}
            {/* Floating chevron button — hidden when sidebar is fully hidden */}
            {sidebarMode !== "hidden" && (
              <IconButton
                onClick={handleChevronClick}
                title="Click to collapse/expand · Double-click to hide"
                sx={{
                  position: "absolute",
                  right: "-15px",
                  top: "40px",
                  backgroundColor: "#009688",
                  color: "#fff",
                  zIndex: 1300,
                  width: "30px",
                  height: "30px",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                  transition: "all 0.3s",
                  "&:hover": {
                    backgroundColor: "#00796B",
                    transform: "scale(1.1)"
                  }
                }}
              >
                {isCollapsed ? <ChevronRightIcon sx={{ fontSize: "20px" }} /> : <ChevronLeftIcon sx={{ fontSize: "20px" }} />}
              </IconButton>
            )}
          </div>
          <div
            className={Style.mainContent}
            style={{
              width: sidebarMode === "hidden" ? "100%" : sidebarMode === "collapsed" ? "calc(100% - 80px)" : "82%",
              transition: "width 0.3s"
            }}
          >
            <header className={Style.header}>
              <Header sidebarHidden={sidebarMode === "hidden"} onShowSidebar={showSidebar} />
            </header>
            <main className={Style.content}>{children}</main>
          </div>

          <Dialog
            open={showHrModal}
            onClose={() => { }}
            PaperProps={{
              sx: {
                padding: "10px",
                borderRadius: "12px",
                minWidth: "350px",
              },
            }}
          >
            <DialogContent>
              <Typography
                sx={{
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1A1C1E",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                Today's Responsibility
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#6C7278",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                {hrLoginData?.assignedName
                  ? `Admin has assigned ${hrLoginData.assignedName} for today. Are you taking the responsibility?`
                  : "Are you responsible for the today assignment of the case?"
                }
              </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", padding: "20px", gap: "10px" }}>
              <Button
                onClick={() => handleHrFirstPerson(false)}
                sx={{
                  flex: 1,
                  height: "45px",
                  borderRadius: "8px",
                  border: "1.5px solid #00913E",
                  color: "#00913E",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(0, 145, 62, 0.04)",
                    border: "1.5px solid #00913E",
                  },
                }}
              >
                No
              </Button>
              <Button
                onClick={() => handleHrFirstPerson(true)}
                sx={{
                  flex: 1,
                  height: "45px",
                  borderRadius: "8px",
                  backgroundColor: "#00913E",
                  color: "#fff",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#007a34",
                  },
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <ItResponsibilityPrompt isAuthenticated={isAuthenticated} />
        </div>

      )}
    </>
  );
};

export default Layout;
